import React from "react";
import { useNavigate } from "react-router-dom";
import "./buysell.css";
import {
  ArrowLeft,
  ArrowRight,
  Home,
  ShieldCheck,
  Plus,
  Search,
  Building2,
} from "lucide-react";

function BuySellHouse() {
  const navigate = useNavigate();

  return (
    <div className="bs-page">

      {/* =================================================
          TOP BAR
      ================================================= */}

      <div className="bs-topbar">

        <button
          className="bs-back-btn"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={18} />
          <span>Back</span>
        </button>

        <div className="bs-brand">
          <span className="bs-brand-dot" />
          CIVILINK
        </div>

      </div>


      {/* =================================================
          HERO
      ================================================= */}

      <section className="bs-hero bs-house-hero">

        <div className="bs-hero-overlay" />

        <div className="bs-hero-content">

          <div className="bs-eyebrow">
            <Home size={15} />
            HOUSE MARKETPLACE
          </div>

          <h1>
            Find a house
            <br />
            <span>worth coming home to.</span>
          </h1>

          <p>
            Buy your next home or list your property
            for buyers looking for the right place.
          </p>

        </div>

      </section>


      {/* =================================================
          MAIN CONTENT
      ================================================= */}

      <main className="bs-main">

        <div className="bs-heading">

          <div>

            <span className="bs-section-label">
              WHAT WOULD YOU LIKE TO DO?
            </span>

            <h2>
              Buy or sell a house
            </h2>

            <p>
              Choose an option to continue.
            </p>

          </div>

        </div>


        {/* =================================================
            OPTIONS
        ================================================= */}

        <div className="bs-options">

          {/* =================================================
              SELL HOUSE
          ================================================= */}

          <button
            className="bs-card bs-sell-card"
            onClick={() => navigate("/sell-house")}
          >

            <div className="bs-card-top">

              <div className="bs-card-icon">
                <Plus size={25} />
              </div>

              <span className="bs-card-arrow">
                <ArrowRight size={19} />
              </span>

            </div>


            <div className="bs-card-content">

              <span className="bs-card-label">
                FOR HOME OWNERS
              </span>

              <h3>
                Sell a House
              </h3>

              <p>
                List your house on Civilink and
                connect with people looking to buy.
              </p>

            </div>


            <div className="bs-card-footer">

              <span>
                Post your property
              </span>

              <ArrowRight size={16} />

            </div>

          </button>


          {/* =================================================
              BUY HOUSE
          ================================================= */}

          <button
            className="bs-card bs-buy-card"
            onClick={() => navigate("/buy-house")}
          >

            <div className="bs-card-top">

              <div className="bs-card-icon">
                <Search size={25} />
              </div>

              <span className="bs-card-arrow">
                <ArrowRight size={19} />
              </span>

            </div>


            <div className="bs-card-content">

              <span className="bs-card-label">
                FOR HOME BUYERS
              </span>

              <h3>
                Buy a House
              </h3>

              <p>
                Explore available homes and find
                a property that matches your needs.
              </p>

            </div>


            <div className="bs-card-footer">

              <span>
                Explore available houses
              </span>

              <ArrowRight size={16} />

            </div>

          </button>

        </div>


        {/* =================================================
            INFORMATION STRIP
        ================================================= */}

        <div className="bs-info-strip">

          <div className="bs-info-item">

            <div className="bs-info-icon">
              <Home size={18} />
            </div>

            <div>

              <strong>
                Explore Homes
              </strong>

              <span>
                Discover available house listings
              </span>

            </div>

          </div>


          <div className="bs-info-item">

            <div className="bs-info-icon">
              <Building2 size={18} />
            </div>

            <div>

              <strong>
                Direct Listings
              </strong>

              <span>
                Connect with property owners
              </span>

            </div>

          </div>


          <div className="bs-info-item">

            <div className="bs-info-icon">
              <ShieldCheck size={18} />
            </div>

            <div>

              <strong>
                Verify Before Buying
              </strong>

              <span>
                Check ownership and documents independently
              </span>

            </div>

          </div>

        </div>


        {/* =================================================
            DISCLAIMER
        ================================================= */}

        <div className="bs-disclaimer">

          <ShieldCheck size={18} />

          <p>
            Civilink is a property listing platform.
            Listings are provided by users and do not
            represent a legal verification or guarantee
            by Civilink. Always inspect the property and
            independently verify ownership, approvals,
            documents and other relevant details before
            making a transaction.
          </p>

        </div>

      </main>

    </div>
  );
}

export default BuySellHouse;